export default __webpack_public_path__ + "static/media/photo1.e7a90ea0.png";